export const setSentryFrontlineContext = () =>
  window.Raven.setTagsContext({
    frontlineBranch: window.FRONTLINE.branch,
    frontlineRevision: window.FRONTLINE.revision,
  });

export const setSentryUserContext = (uuid: string) => window.Raven.setUserContext({ uuid });

export const logErrorToSentry = ({ error = 'Error', ...extra }) => {
  window.Raven.captureException(new Error(error), { extra });
};
